import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltCursorPointerArrowWireframe from './VeltCursorPointerArrowWireframe/VeltCursorPointerArrowWireframe';
import VeltCursorPointerAudioHuddleWireframe from './VeltCursorPointerAudioHuddleWireframe/VeltCursorPointerAudioHuddleWireframe';
import VeltCursorPointerAvatarWireframe from './VeltCursorPointerAvatarWireframe/VeltCursorPointerAvatarWireframe';
import VeltCursorPointerDefaultWireframe from './VeltCursorPointerDefaultWireframe/VeltCursorPointerDefaultWireframe';
import VeltCursorPointerVideoHuddleWireframe from './VeltCursorPointerVideoHuddleWireframe/VeltCursorPointerVideoHuddleWireframe';
var VeltCursorPointerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-cursor-pointer-wireframe", __assign({}, transformedProps), children));
};
VeltCursorPointerWireframe.Arrow = VeltCursorPointerArrowWireframe;
VeltCursorPointerWireframe.AudioHuddle = VeltCursorPointerAudioHuddleWireframe;
VeltCursorPointerWireframe.Avatar = VeltCursorPointerAvatarWireframe;
VeltCursorPointerWireframe.Default = VeltCursorPointerDefaultWireframe;
VeltCursorPointerWireframe.VideoHuddle = VeltCursorPointerVideoHuddleWireframe;
export default VeltCursorPointerWireframe;
